import styles from '../../styles/elements/GalleryHeading.module.scss';

const GalleryName = ({ location, background }) => {
  return (
    <div className={styles.galleryname} style={{ background: `${background}` }}>
      {location}
    </div>
  );
};

export default GalleryName;
